import { Box, Typography } from "@mui/material";
import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { formatNumberToMaximumTenCharacters } from "../../../../common/Common";

interface IClientInfoSetupFieldsPanel {
	clientStoreId: any;
	selectedDataRecord: any;
	isAdminUser: number;
	savedStatus: any,
	id: any,
}
export const ClientInfoSetupFieldsPanel: FC<IClientInfoSetupFieldsPanel> = ({
	clientStoreId,
	selectedDataRecord,
	isAdminUser,
	savedStatus,
	id,
}) => {
	return (
		<>
			{selectedDataRecord && selectedDataRecord.sequenceNumber && <Box sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)", marginBottom: "35px", display: "flex", justifyContent: "space-between" }}>
				<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
					Company Account No.
				</Typography>
				<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
					SP {formatNumberToMaximumTenCharacters(selectedDataRecord.sequenceNumber)}
				</Typography>
			</Box>}
			<RHookFormTextFieldWithLabel
				label="Company ID"
				id="companyId"
				testId={`company-id`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Legal Name"
				id="legalName"
				testId={`legal-Name`}
				labelPosition={LabelPosition.Top}
			// required
			/>
			<RHookFormTextFieldWithLabel
				label="Operating Name"
				id="operatingName"
				testId={`Operating-Name`}
				labelPosition={LabelPosition.Top}
			// required
			/>
			<EmailFieldRHF
				label="System Alerts From"
				id="systemAlertsFrom"
				testId={`client-System-Alerts-From`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			// required
			/>
			<EmailFieldRHF
				label="Stub Email From"
				id="stubEmailFrom"
				testId={`client-stubEmailFrom`}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
			// required
			/>
			<RHookFormMaskedTextFieldWithLabel
				id="craBusinessNo"
				label="Business #"
				labelPosition={LabelPosition.Top}
				testId="CRA Business No."
				//   required={!isRequired}
				labelColumns={4}
				fieldColumns={8}
				placeholder={"000000000RP0000"}
				inputMaskPattern={"{000000000RP0000}"}
			// defaultValue={"123123123RT0000"}
			/>
			{/* {isAdminUser === 400 ? <EnhancedDropDownRHFWithLabel
				label="Status"
				selectName="status"
				testId={`Status`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Active", value: 100 },
					{ label: "In-Active", value: 200 },
				]}
				selectedItem={100}
				// required
				labelColumns={4}
				fieldColumns={8}
			/> :
				id && savedStatus && savedStatus !== "" ?
					<Box sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)", marginBottom: "35px", display: "flex", justifyContent: "space-between" }}>
						<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
							Status
						</Typography>
						<Typography sx={{ fontSize: ".875rem", color: "rgba(0, 0, 0, 0.6)" }}>
							{savedStatus}
						</Typography>
					</Box> : <></>
			} */}
			{/* <EnhancedDropDownRHFWithLabel
				label="Invoice Payment Method"
				selectName="invoicePaymentMethod"
				testId={`invoice-payment Method`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Direct Deposit", value: 100 },
					{ label: "PayPal", value: 200 },
					{ label: "Stripe", value: 300 },
				]}
				selectedItem={100}
			/> */}
		</>
	);
};
